<ion-content>
  <div class="container" *ngIf="conversation">
    <div class="header">
      <div class="title">
        <div class="image"
          [image-loader]="conversation.rid === me.uid ? conversation.user.profileImage : conversation.recipient?.profileImage">
        </div>
        {{ conversation.rid === me.uid ? conversation.user?.fullname : conversation.recipient?.fullname }}
      </div>
      <div class="options">
        <ion-button fill="clear" size="small" color="medium" (click)="closeModal(); gotoPage(routes.chat)">
          <ion-icon mode="md" name="close"></ion-icon>
        </ion-button>
      </div>
    </div>

    <div class="wrapper no-padding">
      <div class="scroll-area" #content>
        <div [id]="last ? 'last-item' : 'item' + i"
          *ngFor="let chat of conversation.messages; let i = index; let last = last; trackBy: trackByCreated"
          (press)="onMessageHold(chat)" (click)="chat.info = !chat.info">
          <div [ngClass]="chat.uid === me.uid ? 'from-me' : 'from-them'">
            <p *ngIf="!chat.isMedia" [innerHTML]="chat.content | sanitize: 'html'"></p>
            <div *ngIf="chat.isMedia" class="image" [image-loader]="chat.content"></div>
            <span class="date" *ngIf="chat.info">{{ toDate(chat.createdAt) | amTimeAgo }}</span>
          </div>
          <div class="clear"></div>
        </div>
      </div>
    </div>
  </div>
</ion-content>

<ion-footer>
  <ion-toolbar class="custom-form">
    <ion-buttons slot="start">
      <ion-button class="circle" fill="clear" color="primary" (click)="sendPhoto()">
        <ion-icon name="camera"></ion-icon>
      </ion-button>
    </ion-buttons>

    <textarea elastic-textarea="50" name="message" placeholder="Type message here..." [(ngModel)]="message"></textarea>

    <ion-buttons slot="end">
      <ion-button class="circle" fill="clear" color="primary" (click)="send(message)">
        <ion-icon name="send"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>